module.exports = __webpack_public_path__ + "static/img/recommend-list-9.af811d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-9.png
// module id = 55zf
// module chunks = 1